const APPLICATION_NAME = "Momentum"
const APPLICATION_SECRET = "DFIEK8327FFAEYXNMW103QUMNSGWIKE26SJE"

const TOKEN_NAME = "token";

export { TOKEN_NAME, APPLICATION_NAME, APPLICATION_SECRET }
